import { render, staticRenderFns } from "./Preco.vue?vue&type=template&id=3ea22190&scoped=true&lang=pug"
import script from "./Preco.vue?vue&type=script&lang=js"
export * from "./Preco.vue?vue&type=script&lang=js"
import style0 from "./Preco.styl?vue&type=style&index=0&id=3ea22190&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea22190",
  null
  
)

export default component.exports